import type {
	adminFcInternalSenderReloginInput,
	adminFcInternalSenderStopResumeInput,
	deleteAdminFcInternalSenderInput,
	getAdminCheckTMHistoryInput,
	getAdminFcInternalSenderHistoryInput,
	getAdminFcInternalSenderInput,
	getAdminFcInternalSendersFacetsInput,
	getAdminFcInternalSendersInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAdminCheckTMHistory: getAdminCheckTMHistoryInput;
	useGetAdminFcInternalSenders: getAdminFcInternalSendersInput;
	useGetAdminFcInternalSendersFacets: getAdminFcInternalSendersFacetsInput;
	useGetAdminFcInternalSender: getAdminFcInternalSenderInput;
	useGetAdminFcInternalSenderHistory: getAdminFcInternalSenderHistoryInput;
	useAdminFcInternalSenderRelogin: adminFcInternalSenderReloginInput;
	useAdminFcInternalSenderStopResume: adminFcInternalSenderStopResumeInput;
	useDeleteAdminFcInternalSender: deleteAdminFcInternalSenderInput;
}

const ADMIN_FC_INTERNAL_SENDERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"admin-fc-internal-senders",
	[
		"useGetAdminFcInternalSenders",
		"useGetAdminFcInternalSendersFacets",
		"useGetAdminCheckTMHistory",
		"useGetAdminFcInternalSender",
		"useGetAdminFcInternalSenderHistory",
		"useAdminFcInternalSenderRelogin",
		"useAdminFcInternalSenderStopResume",
		"useDeleteAdminFcInternalSender",
	],
);

export { ADMIN_FC_INTERNAL_SENDERS_SERVICE_KEYS };
